import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { MarqueeStrip } from "./components/MarqueeStrip";
import { PackagesSection } from "./components/PackagesSection";
import { VisaServices } from "./components/VisaServices";
import { WhyUsSection } from "./components/WhyUsSection";
import { ReviewsSection } from "./components/ReviewsSection";
import { GallerySection } from "./components/GallerySection";
import { PaymentSection } from "./components/PaymentSection";
import { EnquiryForm } from "./components/EnquiryForm";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import PackageDetail from "./pages/PackageDetail";

const HomePage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = "Gautam Travel | Holiday Packages & Visa Services from Delhi";
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, [hash]);

  return (
    <main>
      <HeroSection />
      <MarqueeStrip />
      <PackagesSection />
      <VisaServices />
      <WhyUsSection />
      <ReviewsSection />
      <GallerySection />
      <PaymentSection />
      <EnquiryForm />
    </main>
  );
};

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen overflow-x-hidden bg-ink font-body text-white antialiased">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/package/:slug" element={<PackageDetail />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster theme="dark" position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}
